import { useState, useEffect } from "react";

function GateBackground() {
  return (
    <svg
      className="absolute inset-0 w-full h-full z-0"
      viewBox="0 0 1440 900"
      preserveAspectRatio="xMidYMid slice"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <radialGradient id="gateGlow" cx="50%" cy="30%" r="80%">
          <stop offset="0%" stopColor="#0f2e28" />
          <stop offset="55%" stopColor="#0a1512" />
          <stop offset="100%" stopColor="#050807" />
        </radialGradient>
        <pattern id="gateGrid" width="60" height="60" patternUnits="userSpaceOnUse">
          <path d="M60 0H0V60" fill="none" stroke="#14b8a6" strokeOpacity="0.06" strokeWidth="1" />
        </pattern>
      </defs>
      <rect width="1440" height="900" fill="url(#gateGlow)" />
      <rect width="1440" height="900" fill="url(#gateGrid)" />
      <g stroke="#14b8a6" strokeOpacity="0.18" strokeWidth="1.5" fill="none">
        <line x1="180" y1="120" x2="340" y2="220" />
        <line x1="340" y1="220" x2="300" y2="380" />
        <line x1="340" y1="220" x2="500" y2="180" />
        <line x1="1120" y1="700" x2="1260" y2="600" />
        <line x1="1260" y1="600" x2="1260" y2="440" />
        <line x1="1260" y1="600" x2="1380" y2="680" />
      </g>
      <g fill="#14b8a6" fillOpacity="0.35">
        <circle cx="180" cy="120" r="5" />
        <circle cx="340" cy="220" r="7" />
        <circle cx="300" cy="380" r="4" />
        <circle cx="500" cy="180" r="4" />
        <circle cx="1120" cy="700" r="4" />
        <circle cx="1260" cy="600" r="7" />
        <circle cx="1260" cy="440" r="4" />
        <circle cx="1380" cy="680" r="5" />
      </g>
    </svg>
  );
}

export default function AgeGate({ children }) {
  
  const [needsVerification, setNeedsVerification] = useState(null);
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const verified = sessionStorage.getItem("ageVerified");

    if (!token && !verified) {
      setNeedsVerification(true);
    } else {
      setNeedsVerification(false);
    }
  }, []);

  const handleConfirm = () => {
    sessionStorage.setItem("ageVerified", "true");
    setNeedsVerification(false);
  };

  const handleDeny = () => {
    setBlocked(true);
  };

  // Still checking localStorage — render nothing to avoid a flash
  if (needsVerification === null) return null;

  // User said they're under 21
  if (blocked) {
    return (
      <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-[#050807]">
        <GateBackground />
        <div className="absolute inset-0 bg-black/30 z-10" />
        <div className="relative z-20 w-full max-w-[420px] mx-6 bg-black/50 backdrop-blur-md border border-white/10 rounded-2xl p-10 text-center">
          <h1 className="text-white font-semibold text-[26px] tracking-tight mb-3">
            Access Restricted
          </h1>
          <p className="text-gray-300 text-[15px]">
            You must be 21 years or older to view this site.
          </p>
        </div>
      </section>
    );
  }

  // Needs to confirm age
  if (needsVerification) {
    return (
      <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-[#050807]">
        <GateBackground />
        <div className="absolute inset-0 bg-black/30 z-10" />
        <div className="relative z-20 w-full max-w-[420px] mx-6 bg-black/50 backdrop-blur-md border border-white/10 rounded-2xl p-10">
          <div className="flex flex-col items-center mb-8 text-center">
            <h1 className="text-white font-semibold text-[28px] tracking-tight">
              Age Verification
            </h1>
            <p className="text-gray-300 text-[15px] mt-3">
              You must be 21 years of age or older to enter this site.
              Please confirm your age to continue.
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <button
              onClick={handleConfirm}
              className="gold-glow-btn w-full bg-white hover:bg-gray-200 text-black font-semibold text-[15px] rounded-full py-3 transition-colors"
            >
              I AM 21 OR OLDER
            </button>
            <button
              onClick={handleDeny}
              className="w-full bg-white/5 hover:bg-white/10 border border-white/20 text-gray-300 font-medium text-[15px] rounded-full py-3 transition-colors"
            >
              I AM UNDER 21
            </button>
          </div>

          <p className="text-center text-gray-500 text-xs mt-6">
            By entering, you confirm that you meet the legal age requirement
            in your jurisdiction.
          </p>
        </div>
      </section>
    );
  }

  // Verified (or already has a token) — render the actual app
  return children;
}